module.exports = __webpack_public_path__ + "static/img/3.aa4f96e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/document/5/3.png
// module id = ReKP
// module chunks = 1